export const PLACE_DELIVERY_NOTE = {
    REQUEST: 'PLACE_DELIVERY_NOTE.REQUEST',
    SUCCESS: 'PLACE_DELIVERY_NOTE.SUCCESS',
    FAILED: 'PLACE_DELIVERY_NOTE.FAILED',
};
